<div class="modal-header">
    <h2
        class="modal-title"
        id="exampleModalLabel">
        Delete role
    </h2>
    <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <strong>Are you sure you want to delete this role?</strong>
    All company members who have this role assigned, will have this role removed as well.
</div>

<div class="modal-footer">
    <button
        class="button button--danger"
        (click)="deleteRole()">
        Delete
    </button>
    <button
        type="button"
        class="button button--outline"
        (click)="activeModal.close()">
        Cancel
    </button>
</div>
